import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  fullPage?: boolean;
}

export default function LoadingSpinner({ message = 'Loading...', fullPage = false }: LoadingSpinnerProps) {
  const content = (
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-[var(--sf2)] border-t-[var(--ac)] rounded-full animate-spin" style={{ borderWidth: '3px', borderStyle: 'solid' }} />
      <span className="text-sm text-[var(--tx2)]">{message}</span>
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        {content}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      {content}
    </div>
  );
}
